// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1CDCEnrichmentMode = {
  CDCEnrichmentModeOff: 'OFF',
  CDCEnrichmentModeDiff: 'DIFF',
  CDCEnrichmentModeFull: 'FULL',
} as const;
export type V1CDCEnrichmentMode =
  (typeof V1CDCEnrichmentMode)[keyof typeof V1CDCEnrichmentMode];

export function instanceOfV1CDCEnrichmentMode(value: any): boolean {
  for (const key in V1CDCEnrichmentMode) {
    if (Object.prototype.hasOwnProperty.call(V1CDCEnrichmentMode, key)) {
      if (
        V1CDCEnrichmentMode[key as keyof typeof V1CDCEnrichmentMode] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1CDCEnrichmentModeFromJSON(json: any): V1CDCEnrichmentMode {
  return V1CDCEnrichmentModeFromJSONTyped(json, false);
}

export function V1CDCEnrichmentModeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1CDCEnrichmentMode {
  return json as V1CDCEnrichmentMode;
}

export function V1CDCEnrichmentModeToJSON(
  value?: V1CDCEnrichmentMode | null,
): any {
  return value as any;
}

export function V1CDCEnrichmentModeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1CDCEnrichmentMode {
  return value as V1CDCEnrichmentMode;
}
